import React, { useContext, useEffect } from "react";
import styles from "./stylesFraudDetection.module.css";

import { AppStrings } from "../../../utils/constants/AppStrings";

import FlaggedUsersTable from "./FlaggedUsersTable/FlaggedUsersTable";
import FraudDetectionRulesTable from "./FraudDetectionRulesTable/FraudDetectionRulesTable";
import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import { useLocation } from "react-router-dom";
import { useCurrencySymbol } from "../../../hooks/useCurrencySymbol";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

const FraudDetection: React.FC = () => {
  usePageTitle(AppStrings.FRAUD_DETECTION);

  const { setActiveSidebarTab } = useContext(AppContext);
  const location = useLocation();
  const currencySymbol = useCurrencySymbol();
  
  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.COMPLIANCE, "FRAUD_DETECTION");
  }, [setActiveSidebarTab, location.pathname]);

  return (
    <>
      <div className={styles.fraudDetectionContainer}>
        <div className={styles.fraudDetectionContent}>          
          <FraudDetectionRulesTable currencySymbol={currencySymbol} />
          <FlaggedUsersTable />
        </div>
      </div>
    </>
  );
};

export default FraudDetection;
